/**
 * S1402 — le message de la chargée à l'accueil, sens retour de la note de
 * l'accueil (décision 343). Quand la vérification dure, celle qui vérifie
 * écrit au comptoir (« j'appelle encore les RH », « patientez un peu ») au
 * lieu de se téléphoner. Il informe, il ne tranche rien.
 *
 * Mêmes règles que la note : texte court, écrit tant que l'attente n'est pas
 * tranchée, figé ensuite ; lu par l'accueil du centre où le patient attend.
 * Qui l'écrit : qui confirme (`patient:confirm`), porté par la route.
 */
import { NOTE_CHARGEE_MAX } from './note-chargee.js';
/** La taille de la note : ce qu'on lit sur une ligne de liste. */
export const MESSAGE_ACCUEIL_MAX = NOTE_CHARGEE_MAX;
//# sourceMappingURL=message-accueil.js.map